import React from "react";
import DynamicForm from "components/DynamicForm";

function RecursiveViewBlock(props) {
  const { form_item, selectedData, tabIndex } = props;
  const arrayData = selectedData?.[form_item?.form_field] || [];

  return (
    <>
      {arrayData &&
        arrayData?.map((data, i) => {
          return (
            <div key={i} className="mb-3">
              <DynamicForm
                formFields={{ ...form_item, type: "view_block_card" }}
                selectedData={{
                  ...selectedData,
                  ...data,
                  block_data: data,
                }}
                tabIndex
              />
            </div>
          );
        })}
    </>
  );
}

export default RecursiveViewBlock;
